const serviceUrl = `${__configuration.apiUrl}/massia/tickets`;

export default class TicketApproService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCom(pIdSociete) {
		let url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async createTicketAppro(data) {
		let url = serviceUrl + '/ticket-appro/create';
		const result = await this.$http.post(url, data);
		return result.data;
	}
}
